/**
 * Unified schedule copy — one list in chat for all sources (mail, chat, future).
 * See docs/scheduling.md
 */

/** Umbrella label for the feature and reminders. */
export const SCHEDULE_LABEL = "Termine & Fristen";

/** Section title for the unified agenda. */
export const ANSTEHEND_SECTION_TITLE = "Anstehend";

/** @deprecated Use ANSTEHEND_SECTION_TITLE */
export const SCHEDULE_SECTION_TITLE = "Demnächst";

/** Evening briefing block (from 17:00). */
export const MORGEN_RELEVANT_TITLE = "Morgen relevant";

export const HEUTE_SUBTITLE =
  "Was ansteht — Termine, Fristen und Tagesbriefing.";

export const SCHEDULE_EMPTY_HINT =
  "Noch nichts Anstehendes — sag mir einen Termin oder leite eine Eltern-Mail weiter.";

/** @param {number} days */
export function scheduleLead(days) {
  return `Nächste ${days} Tage — 🔔 steuert Erinnerungen.`;
}

/** Email capture wedge (KiTa, Kindergarten, 0–6). */
export const EARLY_CHILDHOOD_SOURCE = "KiTa & Kindergarten";

export const PARENT_MAIL_LABEL = "Eltern-Mail";

export const ITEM_TYPE_EVENT = "Termin";
export const ITEM_TYPE_TASK = "Aufgabe";

/** After Erledigt — short undo, not an archive. */
export const SCHEDULE_DONE_UNDO_HINT = "Erledigt";
export const SCHEDULE_DONE_UNDO_ACTION = "Rückgängig";

/** Open Aufgaben from mail + saved. */
export const TASKS_SECTION_TITLE = "Aufgaben";

export const TASKS_SECTION_LEAD = "Offen bis erledigt — 🔔 steuert Erinnerungen.";
